import { BoletoDetails } from '../../../../types/Boleto';

export interface BoletoProps {
  modalType?: BoletoModalType;
  boleto: BoletoDetails;
  onClose(viaCloseButton?: boolean): void;
}

export enum BoletoModalType {
  Standard = 'standard',
  Cover = 'cover',
  Overlayed = 'overlayed',
}
